namespace TabAurous.Reports {
    export interface ShortListCategoryWiseRow {
        TransId?: number;
        TransItemId?: number;
        ProductId?: number;
        AttributeId?: number;
        Status?: string;
        Image?: string;
        ImageLength?: number;
        OrderNo?: string;
        ProductCode?: string;
        ProductName?: string;
        StampCode?: string;
        ProductSizeCode?: string;
        SuperTypeCode?: string;
        CategoryCode?: string;
        RefNo?: string;
        Pieces?: number;
        CompanyCode?: string;
        DeptName?: string;
        MetalGrossWeight?: number;
        MetalNetWeight?: number;
        DiamondWeight?: number;
        TotalDiamondWeight?: number;
        PreciousStoneWeight?: number;
        SemiPreciousStoneWeight?: number;
        GrossAmount?: number;
        MF?: number;
        MFAmount?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        PartyId?: number;
    }

    export namespace ShortListCategoryWiseRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Reports.ShortListCategoryWise';
        export const deletePermission = 'Reports:Transaction:Short List';
        export const insertPermission = 'Reports:Transaction:Short List';
        export const readPermission = 'Reports:Transaction:Short List';
        export const updatePermission = 'Reports:Transaction:Short List';

        export declare const enum Fields {
            TransId = "TransId",
            TransItemId = "TransItemId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Status = "Status",
            Image = "Image",
            ImageLength = "ImageLength",
            OrderNo = "OrderNo",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            StampCode = "StampCode",
            ProductSizeCode = "ProductSizeCode",
            SuperTypeCode = "SuperTypeCode",
            CategoryCode = "CategoryCode",
            RefNo = "RefNo",
            Pieces = "Pieces",
            CompanyCode = "CompanyCode",
            DeptName = "DeptName",
            MetalGrossWeight = "MetalGrossWeight",
            MetalNetWeight = "MetalNetWeight",
            DiamondWeight = "DiamondWeight",
            TotalDiamondWeight = "TotalDiamondWeight",
            PreciousStoneWeight = "PreciousStoneWeight",
            SemiPreciousStoneWeight = "SemiPreciousStoneWeight",
            GrossAmount = "GrossAmount",
            MF = "MF",
            MFAmount = "MFAmount",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            PartyId = "PartyId"
        }
    }
}
